import { Connection } from '@3d-scene/model3d/connection';
import { NumberUtils } from '@shared/util/number-utils';
import { ConnectionInfoUtils } from '@3d-scene/model3d/util/connection-info-utils';

export class ConnectionLevel {
  public static readonly DEFAULT_CONNECTION_LEVEL: number = -1;

  private _connectionCubes: Connection[] = [];

  constructor(private _levelNumber: number = NaN) {}

  public get levelNumber(): number {
    return this._levelNumber;
  }

  public get connectionCubes(): Connection[] {
    return this._connectionCubes;
  }

  public addConnectionCube(cube: Connection): void {
    if (!cube) {
      return;
    }
    this._connectionCubes.push(cube);
  }

  public hasConnectionCube(cube: Connection): boolean {
    if (!cube) {
      return false;
    }
    return this._connectionCubes.indexOf(cube) >= 0;
  }

  public getFilteredAcceptingCubes(ignoreMultiplicity: boolean = false): Connection[] {
    return ConnectionInfoUtils.filterAcceptingCubes(this._connectionCubes, ignoreMultiplicity);
  }

  public isDefaultLevel(): boolean {
    return NumberUtils.isNotNumber(this._levelNumber);
  }
}
